// Styles
import styles from './DirectEditBoolean.module.css';

// Table cell layout
import { getDirectEditShellProps } from '../getDirectEditShellClassName';

// Components
import IconButton from '../../../atoms/IconButton/IconButton';
import DirectEditLoadingCell from '../DirectEditLoadingCell/DirectEditLoadingCell';

/**
 * @typedef {object} DirectEditBooleanProps
 * @property {TableCellValueObjectCustom} cellValue - Cell value with directEdit config
 * @property {() => void} onClick - Click handler to toggle and save
 * @property {boolean} isPendingSave - Whether save is in progress
 */

/**
 * BooleanDirectEdit component - Handles direct edit for boolean type
 * Displays icon directly and toggles value on click
 * @param {DirectEditBooleanProps} props
 * @returns {JSX.Element}
 */
function DirectEditBoolean(/** @type {DirectEditBooleanProps} */ {
  cellValue,
  onClick,
  isPendingSave,
}) {
  const booleanConfig = /** @type {any} */ (cellValue?.directEdit)?.boolean;
  const booleanValue = cellValue?.value?.boolean?.value;
  const iconString = booleanValue
    ? (booleanConfig?.trueIcon || 'fal fa-check')
    : (booleanConfig?.falseIcon || 'fal fa-close');

  if (isPendingSave) {
    return (
      <DirectEditLoadingCell cellValue={cellValue}>
        <IconButton
          icon={iconString}
          disabled
          color="no-background"
          size="medium"
          className={styles['direct-edit-boolean-icon']}
        />
      </DirectEditLoadingCell>
    );
  }

  const { className: shellClassName, style: shellStyle } = getDirectEditShellProps(cellValue);

  return (
    <div className={shellClassName} style={shellStyle}>
      <IconButton
        icon={iconString}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        color="no-background"
        size="medium"
        className={styles['direct-edit-boolean-icon']}
      />
    </div>
  );
}

export default DirectEditBoolean;
